
import { defineComponent } from 'vue';
import Top from '../../../../components/Info/Person/Top.vue';
import Middle from '../../../../components/Info/Person/Middle.vue';
import Bottom from '../../../../components/Info/Person/Bottom.vue';
export default defineComponent({
  name: 'Personinfo',
  components: { Top, Middle, Bottom },
});
